import React from "react";

import { TypeFiesta, TypeInsignia } from "@at/design-system-foundation";
import { getMinutesAndHours } from "@at/formatter-utils/lib/time-utils/time.utils";

import { ChargingTabsDetails } from "./charging.styles";
import * as Styled from "./charging.styles";
import { HomeCharging } from "./modals/home-charging-explained";
import { PublicCharging } from "./modals/public-charging-explained";
import { WhatDoesFullChargeMean } from "./modals/what-does-full-charge-mean.modal";
import { ChargingDataProps } from "../../../types/chargin-data.types";

type HowLongToChargeProps = ChargingDataProps & {
  fulWidthStyles?: boolean;
  isDigitalRetailing?: boolean;
};

export const HowLongToCharge = ({
  chargingData,
  fulWidthStyles = false,
}: HowLongToChargeProps) => {
  if (!chargingData || chargingData.chargers?.length === 0) return <></>;

  const fastestChargingDuration = chargingData?.fastestChargingDuration || 0;
  const fastestChargingPower = chargingData?.fastestChargingPower || "";

  return (
    <Styled.Container data-full-width={fulWidthStyles}>
      <TypeInsignia as="h2" weight="400">
        How long will it take to charge?
      </TypeInsignia>

      <TypeFiesta as="p">
        We have used data from the manufacturer to estimate these charging
        times, they are only a guide. Charging times for some speeds may not
        have been provided.
      </TypeFiesta>

      <ChargingTabsDetails>
        <HomeCharging chargers={chargingData?.chargers} />
        <PublicCharging chargers={chargingData?.chargers} />
      </ChargingTabsDetails>
      {fastestChargingDuration && fastestChargingDuration > 0 && (
        <Styled.ChargingTextInfo>
          <TypeFiesta as="span">
            You can charge this vehicle in{" "}
            {getMinutesAndHours(fastestChargingDuration)} at its fastest
            charging speed of {fastestChargingPower} <WhatDoesFullChargeMean />
          </TypeFiesta>
        </Styled.ChargingTextInfo>
      )}
    </Styled.Container>
  );
};
